module.exports = __webpack_public_path__ + "static/img/car-red.00754694.svg";